/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const goalRightNow = useStore((state) => state.goalRightNow);
  const setGoalRightNow = useStore((state) => state.setGoalRightNow);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.goalRightNow.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.goalRightNow.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={goalRightNow}
          onChange={(value: string) => {
            setGoalRightNow(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'goal-right-now',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Lose weight'}>
            <span>🎯</span>
            {t('onboarding.goalRightNow.options.loseWeight')}
          </Option>
          <Option value={'Get fit body'}>
            <span>💪</span>
            {t('onboarding.goalRightNow.options.getFitBody')}
          </Option>
          <Option value={'Eat healthier'}>
            <span>🍽</span>
            {t('onboarding.goalRightNow.options.eatHealthier')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
